import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoneClass;
function None() {
  if (NoneClass === VOID) {
    class $ extends atomicfu$TraceBase() {
      constructor() {
        None_instance = null;
        super();
        None_instance = this;
      }
    }
    initMetadataForObject($, 'None');
    NoneClass = $;
  }
  return NoneClass;
}
var None_instance;
function None_getInstance() {
  if (None_instance === VOID)
    new (None())();
  return None_instance;
}
var atomicfu$TraceBaseClass;
function atomicfu$TraceBase() {
  if (atomicfu$TraceBaseClass === VOID) {
    class $ {
      atomicfu$Trace$append$1(event) {
      }
      atomicfu$Trace$append$2(event1, event2) {
      }
      atomicfu$Trace$append$3(event1, event2, event3) {
      }
      atomicfu$Trace$append$4(event1, event2, event3, event4) {
      }
    }
    initMetadataForClass($, 'TraceBase');
    atomicfu$TraceBaseClass = $;
  }
  return atomicfu$TraceBaseClass;
}
//region block: exports
export {
  None_getInstance as None_getInstance12mvw6h9mcm0i,
};
//endregion

//# sourceMappingURL=Trace.common.mjs.map
